'use client';

import { ReactNode, useEffect } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';
import { AnalyticsScripts } from './AnalyticsScripts';
import { track, captureUTMs, getStoredUTMs, getVisitorStatus } from '@/lib/tracking';

interface AnalyticsProviderProps {
  children: ReactNode;
}

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  useAnalytics();

  useEffect(() => {
    try {
      captureUTMs();
      track('page_view', {
        page_title: document.title,
        page_location: window.location.href,
        ...getVisitorStatus(),
        ...getStoredUTMs(),
      });
    } catch {
      // Silently handle analytics errors
    }
  }, [])
  
  return (
    <>
      <AnalyticsScripts />
      {children}
    </>
  );
};
